import { PanelFlowProvider, usePanelFlowContext } from "./PanelFlowContext";
import type { PanelFlowProps } from "./types";
import { getPanelConfigByKey } from "./utils";

const PanelSwitcher: React.FC = () => {
  const { panelKey, panels } = usePanelFlowContext();
  const config = getPanelConfigByKey(panelKey, panels);

  if (!config) {
    throw new Error(`Invalid panel key, "${panelKey}".`);
  }

  return <config.panel />;
};

export const PanelFlow: React.FC<PanelFlowProps> = (props) => {
  return (
    <PanelFlowProvider {...props}>
      <PanelSwitcher />
    </PanelFlowProvider>
  );
};
